var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from './baseApi';
import { BatchProcessStatus } from '@onereach/types-contacts-api';
import { debouncePromise } from '../utils';
import { FAILED_REQUEST_REPEATS, BULK_POLING_PAUSE_DURATION } from '../constants';
import { CreateContactsBatchError } from '../apiError';
export default class BaseWithPoling extends BaseApi {
    constructor(apiCall, batchProcessApi) {
        super(apiCall);
        this.apiCall = apiCall;
        this.batchProcessApi = batchProcessApi;
    }
    setLogger(logger) {
        this.logger = logger;
    }
    polling(batchId, polingDuration = BULK_POLING_PAUSE_DURATION, repeats = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let batchProcess;
            try {
                batchProcess = yield debouncePromise(() => this.batchProcessApi.getBatchProcess(batchId), polingDuration);
            }
            catch (e) {
                if (repeats < FAILED_REQUEST_REPEATS
                    && 'statusCode' in e
                    && e.statusCode === 'ERR_BAD_REQUEST') {
                    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log(batchId, ' NOT FOUND IN POLING');
                    return yield debouncePromise(() => __awaiter(this, void 0, void 0, function* () {
                        const result = yield this.polling(batchId, polingDuration, repeats + 1);
                        return result;
                    }), (repeats + 1) * polingDuration);
                }
                if (repeats < FAILED_REQUEST_REPEATS) {
                    return this.polling(batchId, polingDuration, repeats + 1);
                }
                throw new CreateContactsBatchError(e.message, batchId);
            }
            if (batchProcess.status === BatchProcessStatus.failed) {
                throw new CreateContactsBatchError('Could not complete batch process', batchId, batchProcess.messages);
            }
            return batchProcess.status === BatchProcessStatus.pending
                ? this.polling(batchId, polingDuration)
                : batchProcess;
        });
    }
}
//# sourceMappingURL=baseWithPolingApi.js.map